module.exports = __webpack_public_path__ + "assets/paypal.d8c03b2b.svg";